import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { bulkInsertRiskAnalysis } from "@/api/endpoints/riskAnalysis";
import type {
  BulkInsertRiskAnalysisRequest,
  BulkInsertRiskAnalysisResponse,
} from "@/types/risk-analysis";

export function useBulkInsertRiskAnalysis(): UseMutationResult<
  BulkInsertRiskAnalysisResponse,
  Error,
  BulkInsertRiskAnalysisRequest,
  unknown
> {
  return useMutation({
    mutationFn: bulkInsertRiskAnalysis,
  });
}
